// import {convertImage, convertToThumbnail, filterImportingFiles, isEXRFile, isVideoFile} from '@/app/File';
import * as IDB from "@/services/indexedDB.service";

const Media = {
    namespaced: true,
    state: {
        active: {
            id: null,
        },
        mediaList: [],
        failedImportList: [],
        tags: {
            status: [
                {
                    label: "No status",
                    value: "no_status",
                    styleColor: "#989898",
                },
                {
                    label: "In progress",
                    value: "in_progress",
                    styleColor: "yellow",
                },
                {
                    label: "Needs review",
                    value: "need_review",
                    styleColor: "blue",
                },
                {
                    label: "Needs revision",
                    value: "need_revision",
                    styleColor: "orange",
                },
                {
                    label: "Approved",
                    value: "approved",
                    styleColor: "green",
                },
            ],
            rating: [
                {
                    label: "None",
                    value: "none",
                },
                {
                    value: 1,
                },
                {
                    value: 2,
                },
                {
                    value: 3,
                },
                {
                    value: 4,
                },
                {
                    value: 5,
                },
            ],
            color: [
                {
                    label: "None",
                    value: "none",
                    styleColor: "#989898",
                },
                {
                    label: "Red",
                    value: "red",
                    styleColor: "red",
                },
                {
                    label: "Orange",
                    value: "orange",
                    styleColor: "orange",
                },
                {
                    label: "Yellow",
                    value: "yellow",
                    styleColor: "yellow",
                },
                {
                    label: "Green",
                    value: "green",
                    styleColor: "green",
                },
                {
                    label: "Blue",
                    value: "blue",
                    styleColor: "blue",
                },
                {
                    label: "Pink",
                    value: "pink",
                    styleColor: "pink",
                },
                {
                    label: "Purple",
                    value: "purple",
                    styleColor: "purple",
                },
            ],
        },
    },
    mutations: {
        SET_MEDIA_LIST: (state, payload) => {
            state.mediaList = payload;
        },

        SET_FAILED_IMPORT_LIST: (state, payload) => {
            state.failedImportList = payload;
        },

        SET_ACTIVE: (state, payload) => {
            state.active = payload;
        },

        SET_TAGS_OF_ACTIVE_MEDIA: (state, payload) => {
            state.active.tags = payload;
        },
    },
    actions: {
        fetchFromLocalStorage: async ({commit}) => {
            let media = await IDB.imagesStore.getItems();
            commit('SET_MEDIA_LIST', media);
        },

        setFailedImportList: ({commit}, payload) => {
            commit('SET_FAILED_IMPORT_LIST', payload);
        },

        fetchDefaultThumbnail: async ({commit}) => {
            let response = await fetch(
                './assets/media/images/fylmai-site-logo-white-project.png');
            let defaultsStoreData = await response.blob();
            defaultsStoreData.extension = '.png';
            return defaultsStoreData;
        },

        switch: async ({commit, dispatch, state}, file) => {
            await dispatch('setActive', file);
        },

        setActive: ({commit, dispatch}, file) => {
            dispatch('resetActive');

            // this.activeMedia.type = fileType;
            file.url = URL.createObjectURL(file.blob);

            commit('SET_ACTIVE', file);
        },

        resetActive: ({state}) => {
            if (!state.active.url) return;
            URL.revokeObjectURL(state.active.url);
        },

        delete: async ({dispatch}, payload) => {
            await imagesStore.removeItem(payload.id);
        },

        deleteAll: async ({dispatch}) => {
            await imagesStore.clear();
        },

        addTag: async ({commit, rootState, state}, payload) => {
            for await (const file_id of payload.file_ids) {
                let storeData = await imagesStore.getItem(file_id);

                storeData.tags.forEach((tag, index) => {
                    if (tag.name == payload.tag_name) {
                        storeData.tags[index] = {
                            name: payload.tag_name,
                            value: payload.tag_value,
                        }
                    }
                })

                await imagesStore.setItem(file_id, storeData);
                if (state.active.id == file_id) {
                    commit('SET_TAGS_OF_ACTIVE_MEDIA', storeData.tags)
                }
            }
        },
        removeTag: async ({commit, rootState, state}, payload) => {
            for await (const file_id of payload.file_ids) {
                let storeData = await imagesStore.getItem(file_id);

                storeData.tags.forEach((tag, index) => {
                    if (tag.name == payload.tag_name) {
                        storeData.tags[index] = {
                            name: payload.tag_name,
                            value: payload.tag_value,
                        }
                    }
                })

                await imagesStore.setItem(file_id, storeData);
                if (state.active.id == file_id) {
                    commit('SET_TAGS_OF_ACTIVE_MEDIA', storeData.tags)
                }
            }
        },
    },
    getters: {
        typeOfActiveMedia: state => type => {
            if (!state.active.type) return;

            let activeMediaExtension = state.active.type;
            if (type == 'exr') return isEXRFile(activeMediaExtension);
            // if (type == 'raw') return isRawFile(activeMediaExtension);
            if (type == 'video') return isVideoFile(activeMediaExtension);
        },

        defaultTags: state => {
            return [
                {
                    name: 'rating',
                    value: 'none'
                },
                {
                    name: 'color',
                    value: 'none'
                },
                {
                    name: 'status',
                    value: 'no_status',
                }
            ]
        }
    },

};

export default Media;
